'use client';

import NavAcessibilidade from '@/components/NavAcessibilidade/NavAcessibilidade';
import Menu from '@/components/Menu/Menu';
import Newsletter from '@/components/Newsletter/Newsletter';
import Footer from '@/components/Footer/Footer';
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import Accordion from '@/components/Accordion/Accordion';
import styles from './Suporte.module.css';
import useGetDuvidasFrequentes from '@/hooks/requestQueries/duvidasFrequentes/getDuvidasFrequentes';
import { useState, useEffect } from 'react';

interface Duvida {
    id: number;
    categoria: string;
    pergunta: string;
    resposta: string;
}

type GroupedData = {
    [categoria: string]: Duvida[];
};

function Suporte() {
    const { data, isLoading, isError } = useGetDuvidasFrequentes();
    const [groupedData, setGroupedData] = useState<GroupedData>({});

    useEffect(() => {
        if (data && !isLoading && !isError) {
            const duvidas: Duvida[] = data.data.duvidasFrequentes;

            // Agrupar os dados por categoria
            const grouped = duvidas.reduce<GroupedData>((acc, item) => {
                if (!acc[item.categoria]) {
                    acc[item.categoria] = [];
                }
                acc[item.categoria].push(item);
                return acc;
            }, {});

            setGroupedData(grouped);
        }
    }, [data, isLoading, isError]);

    return (
        <div>
            <NavAcessibilidade />
            <Menu />
            <div id="conteudo"></div>
            <Breadcrumb titulo="Dúvidas Frequentes" color="blue200" />

            <section className={styles.suporte}>
                <div className={styles.content}>
                    <p tabIndex={0} className={styles.tireDuvidas}>Tire aqui suas principais duvidas sobre a Biblioteca Virtual.</p>

                    {Object.keys(groupedData).map((categoria) => (
                        <div key={categoria}>
                            <h4 tabIndex={0}>{categoria}</h4>
                            <Accordion
                                items={groupedData[categoria].map((item) => ({
                                    id: item.id,
                                    pergunta: item.pergunta,
                                    resposta: item.resposta,
                                }))}
                                showFeedback={true}
                            />
                        </div>
                    ))}
                </div>
            </section>

            <Newsletter />
            <Footer />
        </div>
    );
}

export default Suporte;